import React from 'react';

export const useCopyToClipboard = (params = {}) => {
  const { resetDelayMs = 2000 } = params;

  const [copied, setCopied] = React.useState(false);

  async function copyToClipboard(value) {
    await navigator.clipboard.writeText(value);

    setCopied(true);
  }

  React.useEffect(() => {
    if (copied === true) {
      setTimeout(() => {
        setCopied(false);
      }, resetDelayMs);
    }
  }, [copied, resetDelayMs]);

  return {
    copied,
    copy: copyToClipboard,
  };
};
